import { Box, Description, TextArea, VStack } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { OpenAIChatAction } from 'lib/apiClient'

import { ParamsTable } from '../ParamsTable'
import { Prompt } from './Prompt'
import { DEBUG_ACTION_NAME } from '../consts'
import { Transactions } from './Transactions'

type Props = OpenAIChatAction

export const OpenAIChat: FC<Props> = props => {
  const { name, clientInput, clientOutput, humanReadableOutput } = props

  const { model, messages, promptRevision } = clientInput
  const [firstMessage, ...restMessages] = messages
  const promptContent = firstMessage?.content ?? ''

  // TODO: Create util function to convert rest message to system message (https://revolut.atlassian.net/browse/AIR-177)
  const systemMessages = restMessages
    .filter(message => message.role === 'system')
    .map(({ role, content }) => `**${role}**\n${content}`)
    .join('\n\n')

  return (
    <VStack>
      <Description>Model: {model.name}</Description>
      <Description>Prompt revision: {promptRevision}</Description>
      <VStack>
        <Description>Model parameters:</Description>
        <Box>
          <ParamsTable data={model.parameters} />
        </Box>
        {Boolean(systemMessages.length) && (
          <>
            <Description>Client input:</Description>
            <ParamsTable
              data={{
                messages: systemMessages,
              }}
              markdown
            />
          </>
        )}
      </VStack>
      {name === DEBUG_ACTION_NAME ? (
        <>
          <Prompt defaultValue={promptContent} />
          <Transactions />
        </>
      ) : (
        <>
          <VStack>
            <Description>Prompt:</Description>
            <Box>
              <TextArea defaultValue={promptContent} disabled />
            </Box>
          </VStack>
          <Description>Client output:</Description>
          <ParamsTable
            data={humanReadableOutput ?? clientOutput}
            markdown={Boolean(humanReadableOutput)}
          />
        </>
      )}
    </VStack>
  )
}
